import React from 'react';
import { useForm } from "react-hook-form";
import './Contact.css';
import emailjs from 'emailjs-com';
import swal from 'sweetalert';

const Contact = () => {
      // eslint-disable-next-line
      const { register, handleSubmit, formState: { errors } } = useForm();

      // const onSubmit = data => {
      //       console.log(data)

            
            function sendEmail(e) {
                  e.preventDefault();
                  
            emailjs.sendForm('portfolio_email', 'portfolio_email', e.target, 'user_vKAQbqz8tK2bdlmUCMTIb')
                  .then((result) => {
                        console.log(result.text);
                  }, (error) => {
                        console.log(error.text);
                  });
                  
                  swal("Thank You!", "Your email has successfully been sent.","success")

                  // setTimeout(()=>window.location.href = '/',1500);

                  e.target.reset();
      }

      return (
            <section style={{ fontFamily: 'Roboto Mono',height:'80vh' }} className='container mt-5'>
                  <div className="row">
                        <div className="col-md-6">
                              <h1 className='brand brand-link'>Contact me</h1>
                              <p className='mt-5 text-muted'>I’m interested in freelance opportunities – especially ambitious or large projects. However, if you have other request or question, don’t hesitate to use the form.</p>

                              <form data-aos='fade-up' onSubmit={sendEmail}>
                                    <div className="form-container">

                                          <div className="d-flex row">
                                                <div className="col-md-6">

                                                      <input size='30' className='custom-form form-name mt-3' {...register("user_name", { required: true })} placeholder='Name' autocomplete='off' />

                                                      {errors.user_name && <span class='text-danger'>*required</span>}
                                                </div>

                                                <div className="col-md-6">

                                                      <input size='30' className='custom-form form-email mt-3' {...register("user_email", { required: true })} placeholder='Email' autocomplete='off' />

                                                      {errors.user_email && <span class='text-danger'>*required</span>}
                                                </div>
                                          </div>

                                          <input size='86' className='custom-form form-subject mt-3' {...register("subject", { required: true })} placeholder='Subject' autocomplete='off' />

                                          {errors.subject && <span class='text-danger'>*required</span>}

                                          <br />
                                          <input size='100' className='custom-form form-message mt-3' {...register("message", { required: true })} placeholder='Message' autocomplete='off' />

                                          {errors.message && <span class='text-danger'>*required</span>}
                                    </div>

                                    <div className="col-md-10"></div>
                                    <div className="col-md-2">

                                    </div>
                                    <button className='btn hvr-sweep-to-right mt-3 mb-5 text-align-end'>Send message!</button>
                              </form>


                        </div>
                        <div className="col-md-6">
                              <iframe style={{ height: '100%', width: '100%' }} title='iamRaufu' src="https://www.openstreetmap.org/export/embed.html?bbox=90.41259884834291%2C23.762723181676797%2C90.4298508167267%2C23.771776230936588&amp;layer=mapnik&amp;marker=23.767249785046577%2C90.42122483253479"></iframe>
                        </div>
                  </div>
            </section>
      );
};

export default Contact;